/**
 * Front-end stand-in for the public log routes that aren't deployed yet, so the
 * anonymous flow (upload → analysis → paywall) can be walked end to end today.
 *
 * The numbers here are INVENTED. Nothing parses the visitor's file — only its
 * name is carried through — which is why every surface that renders a demo log
 * must say so. `log.demo` is the flag for that.
 *
 * ponytail: delete this file and the `isDemoId` branches in publicTelemetry.js
 * the day /telemetry/public/* goes live. It only ever runs on a 404.
 */
const key = (id) => `demo-log:${id}`;
const PARSE_MS = 2500; // fake the parse wait so the polling path is exercised

export const isDemoId = (id) => typeof id === "string" && id.startsWith("demo-");

export const createDemoLog = (file) => {
  const id = `demo-${Date.now()}`;
  const log = {
    id,
    demo: true,
    file_name: file.name,
    status: "parsing",
    ready_at: Date.now() + PARSE_MS,
    is_public: true,
    vehicle_type: "Copter",
    tags: ["demo"],
    message_index: {
      BAT: { fields: ["TimeUS", "Volt", "Curr"] },
      BARO: { fields: ["TimeUS", "Alt"] },
      ATT: { fields: ["TimeUS", "Roll", "Pitch"] },
    },
    summary: {
      duration_s: 742,
      firmware: "ArduCopter 4.5.7",
      gps: { sats_min: 11 },
      battery: { volt_min: 21.4, volt_start: 25.1 },
      // Shapes match what LogTimeline reads: modes carry a numeric mode id,
      // events an id — both keyed by microsecond timestamps.
      modes: [
        { t_us: 0, mode: 0 },
        { t_us: 14e6, mode: 5 },
        { t_us: 690e6, mode: 6 },
      ],
      events: [
        { t_us: 2e6, id: 10 },
        { t_us: 741e6, id: 11 },
      ],
    },
  };
  sessionStorage.setItem(key(id), JSON.stringify(log));
  return id;
};

/** Flips to `ready` once the fake parse window has elapsed. */
export const readDemoLog = (id) => {
  const raw = sessionStorage.getItem(key(id));
  if (!raw) return null;
  const log = JSON.parse(raw);
  return { ...log, status: Date.now() >= log.ready_at ? "ready" : "parsing" };
};

/** Smooth synthetic traces — enough for the chart to draw something plausible. */
export const demoMessages = (type, field) => {
  const points = Array.from({ length: 200 }, (_, i) => ({
    TimeUS: i * 3.7e6,
    Volt: 25.1 - i * 0.0185,
    Curr: 28 + 4 * Math.sin(i / 7),
    Alt: 18 + 2 * Math.sin(i / 11),
    Roll: 3 * Math.sin(i / 5),
    Pitch: 2 * Math.cos(i / 6),
  }));
  return { type, fields: [field], count: points.length, total: points.length, truncated: false, points };
};

export const DEMO_INSIGHT = {
  demo: true,
  locked: true,
  preview:
    "Altitude held within 1.8 m of the commanded hover for the whole flight. The pack sagged from 25.1 V to 21.4 V — the last 90 s ran under 3.6 V/cell, which is where you start trading cycles for flight time.",
};
